import { render } from "./OperaView.vue?vue&type=template&id=8114f6c6&scoped=true"
import script from "./OperaView.vue?vue&type=script&lang=js"
export * from "./OperaView.vue?vue&type=script&lang=js"

import "./OperaView.vue?vue&type=style&index=0&id=8114f6c6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Hedde\\OneDrive\\UU\\. Honours\\opera-visualisation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8114f6c6"]])

export default __exports__